package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("QuoteConfirmationProcessStateEntry")
data class QuoteConfirmationProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: QuoteConfirmationProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry {

  override val availableOptions: List<QuoteConfirmationProcessStates>
    get() = QuoteConfirmationProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return processState.format(i18nConfiguration)
  }

  @Serializable
  @SerialName("QuoteConfirmationProcessStates")
  enum class QuoteConfirmationProcessStates : LizergyProcessStates {
    Sent,
    Accepted,
    Rejected,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        Sent -> ProcessStatePhase.Waiting
        Accepted -> ProcessStatePhase.Done
        Rejected -> ProcessStatePhase.Rejected
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        Sent -> "AB versendet"
        Accepted -> "AB angenommen"
        Rejected -> "AB abgelehnt"
      }
    }
  }
}
